import { __assign, __read } from "tslib";
import React, { useRef, useState, useEffect } from 'react';
import { hasContentOverflow } from '@keen.io/charts-utils';
import { Container, AlignmentContainer, Layout, } from './series-horizontal.styles';
import Card from '../card';
import Slider from '../slider';
import { createSliderTransition } from '../legend.utils';
import { BUTTON_DIMENSION, BUTTON_SHADOW_SIZE } from '../slider-button';
var SeriesHorizontal = function (_a) {
    var card = _a.card, alignment = _a.alignment, dataSeries = _a.dataSeries, colorPalette = _a.colorPalette, _b = _a.itemWidth, itemWidth = _b === void 0 ? 100 : _b, _c = _a.itemGap, itemGap = _c === void 0 ? 10 : _c, renderNodes = _a.renderNodes, onOffsetUpdate = _a.onOffsetUpdate;
    var containerRef = useRef(null);
    var elementRef = useRef(null);
    var _d = __read(useState(false), 2), calculationReady = _d[0], setCalculationReady = _d[1];
    var _e = __read(useState([
        0,
        colorPalette.length,
    ]), 2), dataSeriesOffset = _e[0], setDataSeriesOffset = _e[1];
    var _f = __read(useState('list'), 2), renderMode = _f[0], setRenderMode = _f[1];
    var _g = __read(useState([
        0,
        0,
    ]), 2), sliderDimension = _g[0], setSliderDimension = _g[1];
    var _h = __read(useState(0), 2), direction = _h[0], setDirection = _h[1];
    var _j = __read(dataSeriesOffset, 2), startOffset = _j[0], endOffset = _j[1];
    var itemsInSlider = endOffset - startOffset;
    useEffect(function () {
        if (renderMode === 'slider') {
            var colorsInPallete = colorPalette.length;
            var containerWidth = containerRef.current.offsetWidth;
            var dimensionCapacity = Math.floor((containerWidth - 2 * (BUTTON_DIMENSION + BUTTON_SHADOW_SIZE)) /
                (itemWidth + itemGap));
            var itemsInSlider_1 = dimensionCapacity > colorsInPallete
                ? colorsInPallete
                : dimensionCapacity;
            var sliderWidth_1 = itemsInSlider_1 * (itemWidth + itemGap) +
                2 * (BUTTON_DIMENSION + BUTTON_SHADOW_SIZE) -
                itemGap;
            setSliderDimension(function (_a) {
                var _b = __read(_a, 2), height = _b[1];
                return [sliderWidth_1, height];
            });
            setDataSeriesOffset([0, itemsInSlider_1]);
            setCalculationReady(true);
        }
    }, [renderMode]);
    useEffect(function () {
        var notEnoughColors = dataSeries.length > colorPalette.length;
        var contentOverflow = hasContentOverflow('horizontal', containerRef.current);
        if (contentOverflow || notEnoughColors) {
            var sliderHeight = containerRef.current.offsetHeight;
            setSliderDimension([0, sliderHeight]);
            setRenderMode('slider');
        }
        else {
            setCalculationReady(true);
        }
    }, []);
    useEffect(function () {
        onOffsetUpdate([startOffset, endOffset]);
    }, [startOffset, endOffset]);
    return (React.createElement("div", { style: { background: 'transparent', width: '100%', position: 'relative' } },
        React.createElement(Container, { ref: containerRef, calculationReady: calculationReady },
            React.createElement(AlignmentContainer, { alignment: alignment },
                React.createElement(Card, __assign({ borderPosition: "left" }, card), renderMode === 'list' ? (React.createElement(Layout, { itemSpace: itemGap }, renderNodes(dataSeries.slice(0, colorPalette.length), elementRef, itemWidth))) : (React.createElement(Slider, { mode: "horizontal", dimension: sliderDimension, nextDisabled: endOffset >= dataSeries.length, previousDisabled: startOffset === 0, direction: direction, animation: function (itemIndex) {
                        return createSliderTransition('horizontal', itemIndex, itemWidth, itemGap, sliderDimension[0]);
                    }, onNextSlide: function () {
                        setDataSeriesOffset(function (_a) {
                            var _b = __read(_a, 2), startOffset = _b[0], endOffset = _b[1];
                            return [
                                startOffset + itemsInSlider,
                                endOffset + itemsInSlider,
                            ];
                        });
                        setDirection(1);
                    }, onPreviousSlide: function () {
                        setDataSeriesOffset(function (_a) {
                            var _b = __read(_a, 2), startOffset = _b[0], endOffset = _b[1];
                            return [
                                startOffset - itemsInSlider,
                                endOffset - itemsInSlider,
                            ];
                        });
                        setDirection(-1);
                    } }, renderNodes(dataSeries.slice(dataSeriesOffset[0], dataSeriesOffset[1]), elementRef, itemWidth))))))));
};
export default SeriesHorizontal;
